export const SCROLL_ELEMENT_ID = {
	FILTER: 'FILTER',
	DASHBOARD: 'DASHBOARD',
};

export const ScrollElementId = {
	filter: 'FILTER',
	dashboard: 'DASHBOARD',
};

export type ScrollElementIdEnumType = keyof typeof SCROLL_ELEMENT_ID | any;
